import { usePendingReports } from '../../context/PendingReportsContext'

/** Fixed-position toast stack rendered above all views. */
export function NoticeStack() {
  const { notices, dismissNotice, pending } = usePendingReports()

  return (
    <div className="fixed top-16 right-4 z-[60] flex flex-col gap-2 items-end pointer-events-none">
      {pending.size > 0 && (
        <div className="pointer-events-auto bg-[#1a1d27] border border-indigo-500/40 rounded-lg px-3 py-2 text-xs text-indigo-200 shadow-lg flex items-center gap-2">
          <div className="w-3 h-3 rounded-full border-2 border-indigo-400 border-t-transparent animate-spin" />
          Generating report{pending.size > 1 ? 's' : ''}: {Array.from(pending).join(', ')}
        </div>
      )}
      {notices.map(n => (
        <div
          key={n.id}
          className={`pointer-events-auto max-w-xs bg-[#1a1d27] border rounded-lg px-3 py-2 text-xs shadow-lg flex items-start gap-2 ${
            n.tone === 'success' ? 'border-emerald-500/40 text-emerald-200' : 'border-red-500/40 text-red-200'
          }`}
        >
          <span className="flex-1">{n.message}</span>
          <button
            onClick={() => dismissNotice(n.id)}
            className="text-gray-500 hover:text-ink transition-colors"
            aria-label="Dismiss"
          >
            <svg viewBox="0 0 16 16" className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="3" y1="3" x2="13" y2="13" /><line x1="13" y1="3" x2="3" y2="13" />
            </svg>
          </button>
        </div>
      ))}
    </div>
  )
}
